import React from 'react'
import Section from './section'
import { Typography } from '@material-ui/core'

export default ({ text, maxWidth, ...props }) => (
  <Section maxWidth={maxWidth}>
    <Typography {...props}>{text}</Typography>
  </Section>
)